import React, { useRef, useState, useEffect } from 'react';
import Axios from 'axios';
import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as Router from 'react-router-dom';

import * as SYS from '../components/system';

const System = props => {
    const pageGridRef = useRef();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const init = async () => {
        try {
            let dataResp = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/settings`, {
                where: {
                    enable: true
                }
            });
            setData(dataResp.data[0]);
        } catch (err) {

        }
    }

    useEffect(() => {
        setLoading(true);
        init();
        setLoading(false);
    }, []);

    return (
        <>
            <Antd.Layout.Sider className="site-layout-background">
                <Antd.Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%', borderRight: 0 }}
                >
                    <Antd.Menu.Item key="1">
                        <Router.Link to="/system">General</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="21">
                        <Router.Link to="/system/users">Users</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="22">
                        <Router.Link to="/system/user-roles">User roles</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="2">
                        <Router.Link to="/system/connectors">Connectors</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="3">
                        <Router.Link to="/system/datasets">Datasets</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="4">
                        <Router.Link to="/system/pages">Pages</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="5">
                        <Router.Link to="/system/actions">Actions</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="6">
                        <Router.Link to="/system/forms">Forms</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="7">
                        <Router.Link to="/system/caches">Caches</Router.Link>
                    </Antd.Menu.Item>
                    <Antd.Menu.Item key="8">
                        <Router.Link to="/system/logs">Logs</Router.Link>
                    </Antd.Menu.Item>                    
                </Antd.Menu>
            </Antd.Layout.Sider>
            <Antd.Layout.Content>
                <Router.Switch>
                    <Router.Route
                        exact
                        path="/system"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - General'}
                                subTitle={'overview of system settings'}
                                extra={[]}
                            >
                                <SYS.GeneralForm
                                    loading={loading}
                                    initialValues={data}
                                    onSuccess={async (values) => {
                                        setLoading(true);
                                        await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/settings/${data.id}`, values);
                                        await init();
                                        setLoading(false);
                                    }}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/users"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Users'}
                                subTitle={'overview of users'}
                                extra={[]}
                            >
                                <SYS.UserGrid
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/user-roles"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - User roles'}
                                subTitle={'overview of user roles'}
                                extra={[]}
                            >
                                <SYS.UserRoleGrid
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        path="/system/connectors"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Connectors'}
                                subTitle={'overview of system connectors'}
                                extra={[]}
                            >
                                <SYS.ConnectorsGrid />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        path="/system/datasets"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Datasets'}
                                subTitle={'overview of system datasets'}
                                extra={[]}
                            >
                                <SYS.DatasetsGrid />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        path="/system/pages"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Pages'}
                                subTitle={'overview of system pages'}
                                // extra={[
                                //     <Antd.Button
                                //         icon={<AntdIcons.ReloadOutlined />}
                                //         onClick={() => {
                                //             pageGridRef.current.init();
                                //         }}
                                //     />,
                                //     <Antd.Button
                                //         icon={<AntdIcons.PlusOutlined />}
                                //         onClick={() => {
                                //             pageGridRef.current.setPageFormInit({});
                                //         }}
                                //     />
                                // ]}
                            >
                                <SYS.PagesGrid
                                    ref={pageGridRef}
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/actions"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Actions'}
                                subTitle={'overview of system actions'}
                                extra={[]}
                            >
                                <SYS.ActionGrid
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/forms"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Forms'}
                                subTitle={'overview of system forms'}
                                extra={[]}
                            >
                                <SYS.FormGrid
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/caches"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Caches'}
                                subTitle={'overview of system caches'}
                                extra={[]}
                            >
                                <SYS.CacheGrid
                                    showActions={true}
                                />
                            </Antd.PageHeader>
                        )} />
                    <Router.Route
                        exact
                        path="/system/logs"
                        component={props => (
                            <Antd.PageHeader
                                title={'System - Logs'}
                                subTitle={'overview of system logs'}
                                extra={[]}
                            >
                                <SYS.LogEditor />
                            </Antd.PageHeader>
                        )} />
                </Router.Switch>
            </Antd.Layout.Content>
        </>
    );
}

export default System;